import { render } from "./discountRate.vue?vue&type=template&id=2c18cd6a&scoped=true"
import script from "./discountRate.vue?vue&type=script&lang=js"
export * from "./discountRate.vue?vue&type=script&lang=js"

import "./discountRate.vue?vue&type=style&index=0&id=2c18cd6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c18cd6a"]])

export default __exports__